import QRCode from 'qrcode.react';
import { Box, Center, Modal, ModalProps, Stack, Text } from 'ui';

interface DownloadGivebacksAppQRCodeProps extends ModalProps {
  url?: string;
}

const DownloadGivebacksAppQRCodeModal = ({
  opened,
  onClose,
  url = 'https://api.givebacks.com/magic',
}: DownloadGivebacksAppQRCodeProps) => {
  return (
    <Modal opened={opened} onClose={onClose} title="Download the Givebacks App">
      <Stack gap="lg" align="center">
        <Text fw={500}>Scan this code to download the app</Text>
        <Center
          p={36}
          bg="linear-gradient(246deg, #0D32AA -0.01%, #0D3DAA 20.56%, #0D53AA 68.78%, #0D5BAA 100.01%)"
          style={{ borderRadius: 32 }}
        >
          <QRCode value={url} bgColor="transparent" fgColor="white" />
        </Center>
        <Box></Box>
      </Stack>
    </Modal>
  );
};

export { DownloadGivebacksAppQRCodeModal };
